import React from 'react';
import { CountryData, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { AuthPhoneValue } from '../../types/auth';
import { parseAuthPhone } from '../../utils/phone';

interface AuthPhoneInputProps {
    value: string;
    defaultCountry: string;
    countries: CountryData[];
    onChange: (phone: string, fields: AuthPhoneValue) => void;
    onEnter?: () => void;
}

const AuthPhoneInput: React.FC<AuthPhoneInputProps> = ({
    value,
    defaultCountry,
    countries,
    onChange,
    onEnter,
}) => {
    return (
        <div className="auth-form-input-wrapper auth-phone-input">
            <PhoneInput
                defaultCountry={defaultCountry}
                countries={countries}
                preferredCountries={[defaultCountry]}
                value={value}
                disableDialCodeAndPrefix
                showDisabledDialCodeAndPrefix
                disableCountryGuess
                placeholder="Enter WhatsApp Number"
                onChange={(phone, { country }) => {
                    onChange(phone, parseAuthPhone(phone, country.iso2, country.dialCode));
                }}
                inputProps={{
                    autoComplete: 'off',
                    onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            onEnter?.();
                        }
                    },
                }}
                countrySelectorStyleProps={{
                    dropdownStyleProps: {
                        style: { zIndex: 20 },
                    },
                }}
            />
        </div>
    );
};

export default AuthPhoneInput;
